import React from "react";

import { SelectEntityByType } from "../../modules/SelectEntityByType/SelectEntityByType";
import { FiltersFieldsTypes } from "../../modules/SelectEntityByType/constants";

export const DataSelectorActionsField = ({
    className,
    name = "action_code",
    label = "Selector action",
    ...restProps
}) => (
    <SelectEntityByType
        className={className}
        name={name}
        FieldsTypes={FiltersFieldsTypes.dataSelectorAction}
        label={label}
        {...restProps}
    />
);
